export default class Geolocation {
	static async PermissionGranted() {
		return (await (navigator.permissions.query({ name: 'geolocation' }))).state === 'granted';
	}

	static async Geolocate(mode = 'ask') {
		return new Promise(async (resolve) => {
			if (mode === 'auto' && !await this.PermissionGranted()) { resolve(); return; }
			navigator.geolocation.getCurrentPosition((coords) => {
				const { latitude, longitude } = coords.coords;
				fetch(`/lists/json/find-zip-by-lat-lng.ofer?lat=${latitude}&lng=${longitude}`)
					.then((rsvp) => rsvp.json())
					.then((rsvp) => { resolve(JSON.parse(rsvp)); });
			}, () => {
				alert('Prosimy o odblokowanie udostępniania lokalizacji w przeglądarce'); // eslint-disable-line no-alert
				resolve();
			});
		});
	}
}
